import { ProductCardViewData } from '../../../../../features/ProductList/type';
import { ProductCardHelper } from '../../ProductCard/ProductCardHelper';
import { ProductTimeHelper } from '../../ProductCard/utils/ProductTimeHelper';

export class ProductTagHelper {
  static isQuantityLimitedTagVisible(
    data: Pick<ProductCardViewData, 'quantity' | 'order_count' | 'is_quantity_public'>,
  ): boolean {
    const { quantity, order_count, is_quantity_public } = data;
    const stock = quantity - order_count;
    return stock > 0 && stock < 100 && !!is_quantity_public;
  }

  static isPeriodLimitedTagVisible(
    data: Pick<ProductCardViewData, 'sell_start_at' | 'sell_end_at'>,
  ): boolean {
    return (
      ProductCardHelper.isPeriodLimited(data) &&
      this.isPeriodLimitedTagLabelVisible(data.sell_end_at) &&
      !ProductCardHelper.isBeforeSale(data) &&
      !ProductCardHelper.isEndedSale(data)
    );
  }

  /**
   * 기간한정 상품 종료까지 96시간 이상 남아있으면 숨겨진다.
   */
  static isPeriodLimitedTagLabelVisible(sell_end_at: Date): boolean {
    const diff = ProductTimeHelper.diffDate(sell_end_at, new Date());

    const is_hidden =
      diff.day >= 4 || (diff.day === 0 && diff.hour === 0 && diff.minute === 0 && diff.second <= 0);

    return !is_hidden;
  }
}
